<script setup>
import { onMounted, computed, ref } from "vue";
import { useStore } from "vuex";

const store = useStore();

const course = computed(() => store.getters["course/getCourse"]);

const courseProvider = computed(() => course.value.tee_provider);

const isLoading = computed(() => store.getters["course/isCourseUpdating"]);

const form = ref({
  courseName: "",
  contractDevices: 0,
  type: "",
  packageId: "",
  status: "",
});

const isFormValid = computed(() => !!form.value.type && !!form.value.status);

form.value.courseName = course.value.name;
form.value.contractDevices = course.value.contract_devices;
form.value.type = course.value.type;
form.value.packageId = course.value.package_id ?? "";
form.value.status = course.value.status;

async function handleSubmit() {
  try {
    store.dispatch("course/updateCourse", {
      courseId: course.value.id,
      data: {
        name: form.value.courseName,
        contract_devices: form.value.contractDevices,
        type: form.value.type,
        package_id: course.value.package_id,
        status: form.value.status,
      },
    });
  } catch (error) {
    console.error("Failed to update course:", error);
  }
}

onMounted(() => {
  setTimeout(() => {
    window.dispatchEvent(new Event("resize"));
  }, 2500);
});
</script>

<template>
  <div class="col-12">
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">{{ course.name }}</h3>
      </div>
      <div class="card-body">
        <table class="table table-bordered table-hover" id="kpis">
          <thead>
            <tr>
              <th>Name</th>
              <th>Contract Devices</th>
              <th>Provider</th>
              <th>Type</th>
              <th>Package Type</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Name"
                  v-model="form.courseName"
                />
              </td>
              <td>
                <input
                  type="number"
                  class="form-control"
                  placeholder="Contract Devices"
                  v-model="form.contractDevices"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="form-control"
                  v-model="courseProvider"
                  disabled
                />
              </td>
              <td>
                <select id="type" class="form-control" v-model="form.type">
                  <option value="private">PRIVATE</option>
                  <option value="resort">RESORT</option>
                  <option value="daily_fee">DAILY FEE</option>
                </select>
              </td>
              <td>
                <input
                  id="package_id"
                  type="text"
                  class="form-control"
                  placeholder="Package Type"
                  v-model="form.packageId"
                  disabled
                />
              </td>
              <td>
                <select id="status" class="form-control" v-model="form.status">
                  <option value="active">ACTIVE</option>
                  <option value="suspended">SUSPENDED</option>
                  <option value="canceled">CANCELED</option>
                </select>
              </td>
              <td>
                <button
                  class="btn btn-primary"
                  style="width: 100%"
                  @click="handleSubmit"
                  :disabled="isLoading || !isFormValid"
                >
                  <font-awesome-icon
                    v-show="isLoading"
                    :icon="['fas', 'spinner']"
                    spin
                  />
                  <span v-show="!isLoading">UPDATE</span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
